"use client"

import { type ComponentType, createContext, type ForwardRefExoticComponent } from "react"
import type { WidgetType } from "../Widgets/registry"

type PlatformUIKitContextValue = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  linkComponent: ComponentType<any> | ForwardRefExoticComponent<any> | "a"
  // TODO(weedon): Figure out a better place for this if we are going to make widgets live outside PUIK
  // Really only useful for a few products so they can thread down into a bunch of widget rendering spots. Maybe
  // those products can provide their own context and wrap WidgetRenderer instead?
  allowedWidgetTypes?: WidgetType[] | "ALL" | "GA"
  radixPortalContainer?: HTMLElement
  hydrationSafe?: boolean
}

export const PlatformUIKitContext = createContext<PlatformUIKitContextValue | null>(null)
